<template>
    <!--会员卡消费-->
    <el-dialog :visible.sync="visible"
               class="ele-toast" :close-on-click-modal="false" width="660px"  :show-close="false">
        <div slot="title">
            <z-title title="会员卡消费"></z-title>
        </div>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="90px" class=" mt-10">
            <el-form-item label="手机号码">
                {{phone}}
            </el-form-item>
            <el-form-item label="验证码">
                <div class="flex-n fac">
                    <el-input placeholder="请输入验证码" class="w-170" v-model="dataForm.qrcode"></el-input>
                    <el-button class="ml-20"  v-if="sendcodestate!=2" type="primary" @click="sendCode(phone)">{{sendcodestate=='0'?'发送验证码':'重新获取'}}</el-button>
                    <el-button class="ml-20" disabled type="primary" v-else >{{showtime}}s</el-button>

                </div>
            </el-form-item>
            <div class="flex-n fac">
                <el-form-item style="margin-bottom:0" label="会员卡号"> {{memberinfo.memberNo}}
                </el-form-item>
                <el-form-item style="margin-bottom:0" label="会员姓名"> {{memberinfo.memberName}}
                </el-form-item>
                <el-form-item label-width="110px" style="margin-bottom:0" label="会员卡类别">
                    <template v-if="memberinfo.cardType=='01'&&memberinfo.cardDiscount<10">
                        <el-tag size="mini" type="success">{{memberinfo.cardTypeName}}</el-tag>
                        {{memberinfo.cardDiscount}}折
                    </template>
                    <template v-if="memberinfo.cardType=='01'&&memberinfo.cardDiscount==10">
                        <el-tag size="mini" type="warning">{{memberinfo.cardTypeName}}</el-tag>
                    </template>
                    <template v-if="memberinfo.cardType=='02'">
                        <el-tag size="mini" type="success">{{memberinfo.cardTypeName}}</el-tag>
                        {{memberinfo.cardDiscount}}折
                    </template>
                </el-form-item>
                <el-form-item label-width="60px" style="margin-bottom:0" label="余额"
                              v-if="memberinfo.cardType=='01'">
                    {{memberinfo.cardBalance}}
                </el-form-item>
            </div>
            <el-form-item class="mt-10 flex-n fje">
                <el-button type="primary" @click="validateCode(phone,dataForm.qrcode)">确 定
                </el-button>
                <!--showCodeChecked=false;useMemberCard=false;dataForm.memberPhone=''-->
                <el-button @click="cancel">取 消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "use-member-card",
        props:{
            visible: Boolean,
            phone:String,
            memberinfo:Object,
        },
        data(){

          return{
              dataForm: {
                  qrcode:''
              },
              rules:{},
              sendcodestate:0,//0,1是发送重新发送，2是倒计时开始
              showtime:60,
              searchphone: false,
              cleartime:'',
          }
        },
        watch:{
            //倒计时
            showtime(newval,oldval){
                if(newval==0){
                    clearInterval(this.cleartime);
                    this.showtime=60;
                    this.sendcodestate=1;
                }
            }
        },
        methods:{
            //发送验证码
            sendCode(phone) {
                this.$axios.post('/sms/sendSms',{
                    "phone": phone,
                    "type":"SEND_CODE"
                }).then(res=>{
                    this.$message.success('验证码发送成功');
                    this.sendcodestate=2;
                    this.cleartime=setInterval(()=>{
                        this.showtime--;
                    },1000)
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            validateCode(phone, code) {
                this.$axios.post('/sms/validCode',{
                    "phone": phone,
                    "code": code
                }).then(res=>{
                    this.$message.success('手机号验证成功');
                    this.resetForm();
                    this.$emit('success');
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            cancel(){
                this.$emit('cancel');
                this.resetForm();
            },
            resetForm(){
                clearInterval(this.cleartime);
                this.showtime=60;
                this.sendcodestate=0;
                this.$emit('update:visible', false);
            },

        }
    }
</script>

<style scoped>

</style>